<template>
  <div class="flex flex-col gap-8 w-full">
    <!-- Bootcamps section -->
    <div class="flex gap-4 flex-col w-full">
      <div class="h-5 w-24 bg-gray-800 rounded animate-pulse" />
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
        <div v-for="i in 3" :key="i" class="bg-gray-900 rounded-lg w-full flex flex-col overflow-hidden">
          <div class="w-full aspect-[2.25] bg-gray-800 animate-pulse" />
          <div class="p-4 flex flex-col gap-4 divide-y divide-gray-800 flex-1">
            <div class="flex gap-2 flex-wrap">
              <div class="h-6 w-28 bg-gray-800 rounded animate-pulse" />
              <div class="h-6 w-24 bg-gray-800 rounded animate-pulse" />
            </div>
            <div class="flex flex-col gap-2 pt-4 flex-1">
              <div class="h-6 w-3/4 bg-gray-800 rounded animate-pulse" />
              <div class="h-4 w-full bg-gray-800 rounded animate-pulse" />
              <div class="h-4 w-2/3 bg-gray-800 rounded animate-pulse" />
            </div>
            <div class="flex w-full pt-4 items-center justify-between">
              <div class="flex gap-3">
                <div class="h-16 w-16 rounded-full bg-gray-800 animate-pulse" />
                <div class="h-16 w-16 rounded-full bg-gray-800 animate-pulse" />
              </div>
              <div class="h-6 w-12 bg-gray-800 rounded animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Routines section -->
    <div class="flex flex-col gap-4">
      <div class="flex gap-4 items-center">
        <div class="h-5 w-20 bg-gray-800 rounded animate-pulse" />
        <div class="flex justify-end w-full flex-1 gap-4">
          <div class="flex gap-2">
            <div class="h-8 w-8 bg-gray-800 rounded-md animate-pulse" />
            <div class="h-8 w-8 bg-gray-800 rounded-md animate-pulse" />
          </div>
          <div class="relative">
            <div class="h-8 w-42 bg-gray-800 rounded-md animate-pulse" />
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-1 rounded-lg w-full overflow-hidden">
        <div v-for="i in 3" :key="i" class="bg-gray-900 p-4">
          <div class="h-6 w-1/3 bg-gray-800 rounded animate-pulse mb-2" />
          <div class="h-4 w-2/3 bg-gray-800 rounded animate-pulse" />
        </div>
      </div>
    </div>

    <!-- Sets section -->
    <div class="flex flex-col gap-4">
      <div class="flex gap-4 items-center">
        <div class="h-5 w-16 bg-gray-800 rounded animate-pulse" />
        <div class="flex justify-end w-full flex-1 gap-4">
          <div class="flex gap-2">
            <div class="h-8 w-8 bg-gray-800 rounded-md animate-pulse" />
            <div class="h-8 w-8 bg-gray-800 rounded-md animate-pulse" />
          </div>
          <div class="relative">
            <div class="h-8 w-42 bg-gray-800 rounded-md animate-pulse" />
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-1 rounded-lg w-full overflow-hidden">
        <div v-for="i in 3" :key="i" class="bg-gray-900 p-4">
          <div class="h-6 w-1/3 bg-gray-800 rounded animate-pulse mb-2" />
          <div class="h-4 w-2/3 bg-gray-800 rounded animate-pulse" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Pure skeleton component
</script>
